<template>
  <div class="date-tab__text">
    <p>Please select your preferred date and time.</p>
    <p>
      Can't see the dates you want?
      <RouterLink class="chat-with-team-link" :to="chatWithTeamAboutTicketsRoute">Chat with our team</RouterLink
      >&nbsp;&ndash; we'll do our best to make it happen.
    </p>
    <p v-if="showArrangingTourNotice" class="arranging-tour-notice">
      Tours require 48 hours notice. We will do our best to accommodate last-minute requests.
    </p>
  </div>
</template>

<script>
import { getLookingForTicketsMessage } from '@/helpers/booking';

export default {
  name: 'AppBookingDateTimeStepText',
  props: {
    eventTitle: {
      type: String,
      default: '',
    },
    showArrangingTourNotice: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chatWithTeamAboutTicketsRoute() {
      const query = this.eventTitle
        ? {
            text: getLookingForTicketsMessage(this.eventTitle),
          }
        : {};

      return {
        path: '/contact-us',
        query,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.chat-with-team-link {
  margin-left: 4px;
  color: vars.$c-link-7b;
  text-decoration: underline;
  font-weight: 400;

  &:hover,
  &:focus {
    color: vars.$c-link-7b !important;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: 4px;
    vertical-align: -2px;
    background-color: currentColor;
    $icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 11.2 21 3l-6.2 18-3.4-7.4L3 11.2Z'/%3E%3Cpath d='M11.4 13.6 21 3'/%3E%3C/svg%3E");
    -webkit-mask: $icon no-repeat center / contain;
    mask: $icon no-repeat center / contain;
  }
}
</style>
